<template>
    <v-container>
        <v-row>
            <v-col
                cols="12"
                sm="6"
            >
                <v-img
                    class="my-5"
                    :src="require('../assets/access_denied.svg')"
                />
            </v-col>
            <v-col
                class="text-center text-sm-left"
                cols="12"
                sm="6"
            >
                <div class="d-flex flex-column fill-height justify-center">
                    <h1>Not Authorized</h1>
                    <p class="body-1">
                        You are not authorized to view this page.
                    </p>
                    <div>
                        <v-btn
                            color="primary"
                            :to="{name: 'home'}"
                        >
                            Homepage
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {

}
</script>
